export const selectCartState = (state) => state.cart;

export const selectCartItems = (state) => state.cart.items;

export const selectCartTotalQuantity = (state) => {
    const items = state.cart.items;
    let total = 0;
    for (let i = 0; i < items.length; i++) {
        total += items[i].quantity;
    }
    return total;
};

export const selectIsItemInCart = (state, productId) => {
    const items = state.cart.items;
    return items.some(item => item.id === productId);
};

export const selectCartItemById = (state, cartItemId) => {
    return state.cart.items.find(item => item.cartItemId === cartItemId) || null;
};

export const selectCartItemsByProductId = (state, productId) => {
    return state.cart.items.filter(item => item.id === productId);
};

export const selectCartTotalPrice = (state) => {
    const items = state.cart.items;
    let total = 0;
    for (let i = 0; i < items.length; i++) {
        const price = items[i].price || 0;
        total += price * items[i].quantity;
    }
    return total;
};

export const selectItemQuantityInCart = (state, productId) => {
    const items = state.cart.items;
    const item = items.find(item => item.id === productId);
    return item ? item.quantity : 0;
};

export const selectIsCartEmpty = (state) => state.cart.items.length === 0;

export const selectAllItemsVirtual = (state) => {
    const items = state.cart.items;
    return items.length > 0 && items.every(item => item.virtual);
};

export const selectCartItemsForServer = (state) => {
    const fullCartItems = selectCartItems(state);

    return fullCartItems.map(item => {
        return {
            id: item.id,
            cartItemId: item.cartItemId,
            quantity: item.quantity,
            variationId: item.variationId || "",
            packaging: item.packaging || "",
            warehouse: item.warehouse || "",
            virtual: item.virtual || false,
        };
    });
};

export const cartSelectors = {
    selectCartState,
    selectIsItemInCart,
    selectCartItemById,
    selectCartItemsByProductId,
    selectCartItems,
    selectCartTotalQuantity,
    selectCartTotalPrice,
    selectIsCartEmpty,
    selectItemQuantityInCart,
    selectCartItemsForServer,
    selectAllItemsVirtual,
};